import { Input } from 'antd';
const TextBox = (props) => {
	const this_OnChange = (e) => {
		if (props.onChange) { props.onChange(e.target.value); }
	};

	return (
		<Input value={props.cValue} placeholder={props.placeholder} onChange={this_OnChange} />
	);
}
export default TextBox;